import React from 'react';
import PropTypes from 'prop-types';

import styles from './selectAllCheckbox.scss';

const SelectAllCheckBox = (props) => {
    const {
        onClearAll,
        onSelectAll,
        areSomeSelected,
        className,
        disabled,
        label,
        'data-testid': dataTestId,
    } = props;

    const onCheckToggle = (ev) => {
        if (areSomeSelected) {
            onClearAll(ev);
        } else {
            onSelectAll(ev);
        }
    };

    return (
        <div
            className={`${styles.checkBox} ${disabled ? styles.disabled : ''} ${className}`}
            data-testid={dataTestId}
        >
            <div
                className={`${styles.checkIcon} ${areSomeSelected ? styles.selected : ''} ${areSomeSelected ? 'fas fa-minus' : ''}`}
                onClick={onCheckToggle}
                data-testid={dataTestId && `${dataTestId}.check-icon`}
            />
            {label && (
                <div
                    className={`${styles.label}`}
                    onClick={onCheckToggle}
                    data-testid={dataTestId && `${dataTestId}.label`}
                >
                    {label}
                </div>
            )}
        </div>
    );
};

SelectAllCheckBox.propTypes = {
    className: PropTypes.string,
    onClearAll: PropTypes.func.isRequired,
    onSelectAll: PropTypes.func.isRequired,
    areSomeSelected: PropTypes.bool,
    disabled: PropTypes.bool,
    label: PropTypes.string,
    'data-testid': PropTypes.string,
};

SelectAllCheckBox.defaultProps = {
    className: '',
    label: null,
    areSomeSelected: false,
    disabled: false,
    'data-testid': undefined,
};

export default SelectAllCheckBox;
